import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { clientTypes, availabilityPrograms } from "./data";

export const AvailabilityEditor = ({ valueGetter, onChange, registered, atype }) => {
  const clientType = valueGetter("client_type") || "All";

  const handleChange = (field, value) => {
    onChange(field, { value });
  };

  console.log("registered.programs:", registered?.programs);
  console.log(
    "Perinatal enabled:",
    registered?.programs?.some((p) => p.identifier === "pgnl" && p.enabled === true),
  );

  const isProgramDisabled = (program) =>
    (program.name === "Program_CentralisedService" && registered.specialisttype !== "centralisedservice") ||
    (program.name === "Program_NDIS" && registered.eapContractNDISAvailability !== "Y") ||
    (program.name === "Program_EAP" && registered.eapAvailability !== "Y") ||
    (program.name === "Program_Perinatal" && !registered.programs?.some((p) => p.identifier === "pgnl" && p.enabled === true)) ||
    program.name === "Group";

  const allProgramsSelected = availabilityPrograms.filter((program) => !isProgramDisabled(program)).every((program) => Boolean(valueGetter(program.name)));

  const handleSelectAll = (checked) => {
    availabilityPrograms.forEach((program) => {
      if (!isProgramDisabled(program)) {
        handleChange(program.name, checked);
      }
    });
  };

  return (
    <div className="availability-settings">
      {/* Unavailable Label */}
      {atype === "Unavailable" && (
        <div className="mb-4">
          <Form.Label className="availability-label">Description (Optional)</Form.Label>

          <Form.Control
            type="text"
            name="label"
            placeholder="e.g. Leave, Training, Admin"
            value={valueGetter("label") || ""}
            onChange={(e) => handleChange("label", e.target.value)}
          />
        </div>
      )}

      {atype === "Availability" && (
        <>
          {/* Client Availability Type */}
          <div className="mb-4">
            <Form.Label className="availability-label">Client Availability Type</Form.Label>

            <div className="availability-client-types">
              {clientTypes.map((item) => (
                <Form.Check
                  key={item.value}
                  inline
                  type="radio"
                  name="clientAvailabilityType"
                  id={`client-${item.value}`}
                  label={item.text}
                  value={item.value}
                  checked={clientType === item.value}
                  onChange={() => handleChange("client_type", item.value)}
                />
              ))}
            </div>
          </div>

          {/* Programs */}
          <div className="mb-4">
            <Form.Label className="availability-label">
              Program <span className="text-danger">*</span>
            </Form.Label>

            <p className="availability-description availability-description-note">Client will see availability for all types selected when making bookings.</p>

            <div className="availability-program-panel">
              {/* Select All */}
              <div className="availability-program-all">
                <Form.Check
                  type="checkbox"
                  id="availability-program-all"
                  label="All"
                  checked={allProgramsSelected}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
              </div>
              {/* Individual Programs */}
              {/* Individual Programs */}
              <div className="availability-program-grid">
                {availabilityPrograms.map((program) => {
                  const isDisabled = isProgramDisabled(program);

                  return (
                    <Form.Check
                      key={program.name}
                      type="checkbox"
                      id={program.name}
                      label={program.label}
                      checked={Boolean(valueGetter(program.name))}
                      disabled={isDisabled}
                      onChange={(e) => handleChange(program.name, e.target.checked)}
                    />
                  );
                })}
              </div>
            </div>

            <p className="availability-description availability-description-note mt-3">
              You can enable and disable options in your profile or by contacting the RHC admin team to opt into programs.
            </p>
          </div>
        </>
      )}
    </div>
  );
};
